import { MultiSuggestSegmentItem } from '@lp/features/MultiSuggest';
import { SEGMENT_NAME_MAP } from '@lp/features/MultiSuggest/utils';
import { RouteLeg } from './RouteLeg';
import { formatTimestamp } from '@/utils/helpers';

export const RouteSegment = ({ segmentType, legs }: MultiSuggestSegmentItem) => {
  const dateString = formatTimestamp(legs[0].departureTime, legs[0].departureLocalTimezone, 'MM/dd/yyyy');

  return (
    <div className="flex flex-col gap-0.5">
      <div className="flex justify-between items-center">
        <span className="text-s-sb text-base-10">{SEGMENT_NAME_MAP[segmentType]}</span>
        <span className="text-s-sb text-base-10">{dateString}</span>
      </div>
      {legs.map((leg) => (
        <RouteLeg key={leg.id} leg={leg} />
      ))}
    </div>
  );
};
